import { render, staticRenderFns } from "./orderForm.vue?vue&type=template&id=20c59054"
import script from "./orderForm.vue?vue&type=script&lang=js"
export * from "./orderForm.vue?vue&type=script&lang=js"
import style0 from "./orderForm.vue?vue&type=style&index=0&id=20c59054&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports